module.exports = __webpack_public_path__ + "media/packs/images/flags/GU-ed285f0794dfef8b6e3f5f7f2dc1880b.svg";